import { CancelSmall } from '@app/components/various/Icons';
import { cn } from '@app/utils/cn';
import { isEmpty } from '@app/utils/isEmpty';
import { Selects } from '@typings';

import { useSelectContext } from '../context/SelectContext';

interface Props {
  renderValue: (value: Selects.NonNullableValue) => string | undefined;
}

export const Pills = ({ renderValue }: Props) => {
  const { selection, handleSelect, focusedPillPosition, isReadOnly } = useSelectContext();

  const handleClick = (value: Selects.NonNullableValue) => (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    handleSelect(value);
  };

  if (!Array.isArray(selection) || isEmpty(selection)) {
    return null;
  }

  return (
    <>
      {selection.map((value, index) => (
        // Mouse down is used to prevent the blur event from firing
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <div
          key={value}
          className={cn(
            'flex h-6 items-center gap-1 rounded-large bg-neutral-96 pl-2 pr-1 text-neutral-20 body-5 focus-visible:bg-white focus-visible:focus-outline',
            { 'bg-white': isReadOnly, 'focus-outline': index === focusedPillPosition },
          )}
          onMouseDown={event => event.stopPropagation()}
          onClick={event => event.stopPropagation()}
          data-sentry-mask
        >
          {renderValue(value)}
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
          <div
            role="button"
            tabIndex={-1}
            className={cn('cursor-pointer text-neutral-40 hover:text-neutral-20', { 'text-neutral-20': index === focusedPillPosition })}
            onMouseDown={event => event.preventDefault()}
            onClick={handleClick(value)}
          >
            {!isReadOnly && <CancelSmall className="h-3 w-3" />}
          </div>
        </div>
      ))}
    </>
  );
};
